const GET_JOB_TITLE_GRID_DATA = 'GET_JOB_TITLE_GRID_DATA';
const SET_JOB_TITLE_GRID_DATA = 'SET_JOB_TITLE_GRID_DATA';

const GET_JOB_TITLE_EXCEL_DATA = 'GET_JOB_TITLE_EXCEL_DATA';
const SET_JOB_TITLE_EXCEL_DATA = 'SET_JOB_TITLE_EXCEL_DATA';

const GET_SAVE_JOB_TITLE = 'GET_SAVE_JOB_TITLE';
const IS_JOB_TITLE_SAVED = 'IS_JOB_TITLE_SAVED';

const GET_EDIT_JOB_TITLE_DATA_BY_ID = 'GET_EDIT_JOB_TITLE_DATA_BY_ID';
const SET_EDIT_JOB_TITLE_DATA_BY_ID = 'SET_EDIT_JOB_TITLE_DATA_BY_ID';

const GET_SAVE_MULTIPLE_JOB_TITLE_STATUS = 'GET_SAVE_MULTIPLE_JOB_TITLE_STATUS';
const SET_SAVE_MULTIPLE_JOB_TITLE_STATUS = 'SET_SAVE_MULTIPLE_JOB_TITLE_STATUS';

export {
    GET_JOB_TITLE_GRID_DATA,
    SET_JOB_TITLE_GRID_DATA,

    GET_JOB_TITLE_EXCEL_DATA,
    SET_JOB_TITLE_EXCEL_DATA,

    GET_SAVE_JOB_TITLE,
    IS_JOB_TITLE_SAVED,

    GET_EDIT_JOB_TITLE_DATA_BY_ID,
    SET_EDIT_JOB_TITLE_DATA_BY_ID,

    GET_SAVE_MULTIPLE_JOB_TITLE_STATUS,
    SET_SAVE_MULTIPLE_JOB_TITLE_STATUS
};